var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 842 596",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 840,
    height: 595.3,
    style: {
      fill: "#f92121"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 420.9,
    cy: 296.5,
    rx: 309.1,
    ry: 283.5,
    style: {
      fill: "#f4f90a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 100,
    width: 640,
    height: 390,
    style: {
      fill: "#fa2929"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225,
    cy: 310,
    rx: 105,
    ry: 120,
    style: {
      fill: "#fa3030"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.861103,0,0,1,-4.29362,0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(247.409,0,0,247.409,324.804,437.101)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "187.207px",
    y: "437.101px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: "247.409px"
    }
  }, "d")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.244816,-7.10543e-15,273.743)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(512.366,0,0,512.366,708.778,841.639)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "281.973px",
    y: "841.639px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: "512.366px"
    }
  }, "M"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c31f5834c8ffcfa44510e4b11aab57f0.svg";
export { ForwardRef as ReactComponent };